import axios from '@axios'
import constants from '@/app-configs/constants'
import apitokens from './apitokens'
import apisettings from './apisettings'
import adminsettings from './adminsettings'
// import usersettings from './usersettings'
import users from './users'
import partner from './partner'
import filecategories from './filecategories'
import statementgroups from './statementgroups'
import contacts from './contacts'

async function getTranslations() {
  const { data } = await axios.get('translations/system-locales')

  return data.data.map(e => ({
    title: e.language,
    route: {
      name: 'translations',
      params: { lang: e.code },
      meta: {
        navActiveLink: e.code,
      },
      icon: 'GridIcon',
    },

  }))
}

async function getSuperAdminTranslations() {
  const { data } = await axios.get('translations/system-locales')

  return data.data.map(e => ({
    title: e.language,
    route: {
      name: 'translations',
      params: { lang: e.code },
      meta: {
        navActiveLink: e.code,
      },
      icon: 'GridIcon',
    },
    action: constants.action.permissionTranslationView,
    resource: constants.resource.translation,

  }))
}

export default async function settings() {
  return [
    {
      title: 'DEBTIA_SETTINGS',
      icon: 'GridIcon',
      action: 'settings',
      resource: 'settings',
      children: [
        ...users,
        ...partner,
        {
          title: 'DEBTIA_PROCESSES',
          route: 'processes',
          icon: 'ActivityIcon',
          action: constants.action.permissionProcessList,
          resource: constants.resource.process,
        },
        ...filecategories,
        // ...statementgroups,
        ...apitokens,
        ...apisettings,
        ...contacts,
        // ...usersettings,
        {
          title: 'DEBTIA_TRANSLATIONS',
          route: 'translations',
          action: 'settings',
          resource: 'settings',
          children: await getTranslations(),
        },
        {
          title: 'DEBTIA_ROLE_MANAGEMENT',
          route: 'role-management',
          action: 'settings',
          resource: 'settings',
        },
        ...adminsettings,
        {
          title: 'DEBTIA_STUCK_CASES',
          icon: 'GridIcon',
          route: 'stuck-cases',
          action: constants.action.permissionStuckCases,
          resource: constants.resource.user,
        },
      ],
    },
    {
      title: 'DEBTIA_SETTINGS',
      icon: 'GridIcon',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
      companyOnly: true,
      children: [
        ...users,
        ...partner,
        ...filecategories,
        ...statementgroups,
        ...contacts,
        {
          title: 'DEBTIA_PROCESSES',
          route: 'processes',
          icon: 'ActivityIcon',
          action: constants.action.permissionProcessList,
          resource: constants.resource.process,
        },
        {
          title: 'DEBTIA_ADMIN_SETTINGS',
          route: 'admin-settings',
          icon: 'GridIcon',
          action: constants.action.permissionUserSettings,
          resource: constants.resource.user,
        },
        {
          title: 'DEBTIA_TRANSLATIONS',
          route: 'translations',
          action: constants.action.permissionTranslationView,
          resource: constants.resource.translation,
          children: await getSuperAdminTranslations(),
        },
        ...apitokens,
        ...apisettings,
        // ...usersettings,
        {
          title: 'DEBTIA_STUCK_CASES',
          icon: 'GridIcon',
          route: 'stuck-cases',
          action: constants.action.permissionStuckCases,
          resource: constants.resource.user,
        },
      ],
    },
  ]
}
